module.exports = __webpack_public_path__ + "static/EM2-3c5777ff35d2a1aa9f398febf03e3154.png";